/* ============================================================
   CONFIG, REPLACE
   ============================================================ */
// Populated by the ECG Enquiry form section's schema settings.
const CONFIG = {
  FORM_ENDPOINT: (window.ECG_CONFIG && window.ECG_CONFIG.FORM_ENDPOINT) || null,
  PHONE:         (window.ECG_CONFIG && window.ECG_CONFIG.PHONE) || '0493 352 757'
};

/* logo shows only if images/logo.png exists */
(function(){
  const logo = document.querySelector('.logo');
  if (!logo) return;
  const on = () => logo.closest('.brandwrap').classList.add('haslogo');
  logo.addEventListener('load', on);
  if (logo.complete && logo.naturalWidth > 0) on();
})();

/* photo slots degrade gracefully */
document.querySelectorAll('.ph img').forEach(img => {
  const mark = () => img.closest('.ph').classList.add('empty');
  img.addEventListener('error', mark);
  if (img.complete && img.naturalWidth === 0) mark();
});

/* ============================================================
   Enquiry form, 11 steps with a live price calculator
   ============================================================ */
(function(){
  const form = document.getElementById('leadForm');
  if (!form) return;

  const P        = window.ECG_PRICING || {};
  const CUR      = P.currency || '$';
  const BASE     = Number(P.base) || 0;
  const L        = P.labels || {};
  const steps    = Array.from(document.querySelectorAll('.stepq'));
  const fill     = document.getElementById('chargefill');
  const nextBtn  = document.getElementById('nextBtn');
  const backBtn  = document.getElementById('backBtn');
  const errBox   = document.getElementById('err');
  const title    = document.getElementById('stepTitle');
  const panel    = document.getElementById('pricePanel');
  const ppAmount = document.getElementById('ppAmount');
  const ppLines  = document.getElementById('ppLines');
  const quoteNote= document.getElementById('quoteNote');

  let current = 0, hasAdvanced = false;

  const money = n => CUR + Number(n).toLocaleString('en-AU');
  const val = name => { const el = form.querySelector('input[name="'+name+'"]:checked'); return el ? el.value : null; };
  const addOf = name => { const el = form.querySelector('input[name="'+name+'"]:checked'); return el ? Number(el.dataset.add || 0) : 0; };

  /* ---- quote-only paths ---- */
  function quoteMode(){
    if (val('residence_type') === 'Apartment') return 'apartment';
    if (val('cable_run') === 'Over 25m') return 'longrun';
    return null;
  }

  /* ---- price ---- */
  function lines(){
    const out = [{label: L.base || 'Supplied and installed', amount: BASE}];
    const map = [['storeys','Double',L.double],['roof','Tin',L.tin],['solar','Yes',L.solar],['cable_run','15-25m',L.long]];
    map.forEach(([name, trigger, label]) => {
      const el = form.querySelector('input[name="'+name+'"]:checked');
      if (el && el.value === trigger) out.push({label: label || el.value, amount: Number(el.dataset.add || 0)});
    });
    return out;
  }
  const total = () => lines().reduce((a,l) => a + l.amount, 0);

  function paintPrice(){
    const mode = quoteMode();
    const started = steps[current].dataset.price || steps[current].dataset.contact;

    if (mode){
      panel.hidden = true;
      quoteNote.hidden = !!steps[current].dataset.contact;
      quoteNote.textContent = (P.quote && P.quote[mode]) || '';
      return;
    }
    quoteNote.hidden = true;
    // final step shows the itemised bubble instead, so the top panel steps aside
    if (!started || steps[current].dataset.contact){ panel.hidden = true; return; }

    panel.hidden = false;
    ppAmount.textContent = money(total());
    ppLines.innerHTML = lines().map(l =>
      '<li><span>' + l.label + '</span><span>' + (l.amount === BASE ? money(l.amount) : '+' + money(l.amount)) + '</span></li>'
    ).join('');
  }

  function paintBreakdown(){
    const el = document.getElementById('breakdown');
    if (!el) return;
    const mode = quoteMode();
    if (mode){
      el.className = 'breakdown quote';
      el.innerHTML = '<p>' + ((P.quote && P.quote[mode]) || '') + '</p>';
      return;
    }
    el.className = 'breakdown';
    el.innerHTML =
      '<div class="bd-label">' + (P.panelLabel || 'Your price') + '</div>' +
      '<div class="bd-total">' + money(total()) + '</div>' +
      '<ul>' + lines().map(l =>
        '<li><span>' + l.label + '</span><span>' + (l.amount === BASE ? money(l.amount) : '+' + money(l.amount)) + '</span></li>'
      ).join('') + '</ul>';
  }

  /* ---- steps ---- */
  function render(){
    steps.forEach((s,i) => s.classList.toggle('evcq-on', i === current));
    fill.style.width = Math.round(((current + 1) / steps.length) * 100) + '%';
    title.textContent = steps[current].dataset.title || '';
    backBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
    if (current === steps.length - 1){
      nextBtn.textContent = 'Submit';
    } else if (steps[current].hasAttribute('data-prefilled')) {
      nextBtn.textContent = 'Selected your vehicle, continue';
    } else {
      nextBtn.textContent = 'Continue';
    }
    errBox.classList.remove('show');
    paintPrice();
    if (steps[current].dataset.contact) paintBreakdown();
    if (hasAdvanced){
      const input = steps[current].querySelector('input[type=text],input[type=tel]');
      if (input && window.innerWidth > 700) setTimeout(() => input.focus(), 60);
    }
  }

  form.querySelectorAll('.opt input[type=radio]').forEach(input => {
    input.addEventListener('change', () => {
      form.querySelectorAll('input[name="'+input.name+'"]').forEach(sib =>
        sib.closest('.opt').classList.toggle('sel', sib.checked));
      errBox.classList.remove('show');
      paintPrice();
    });
  });

  function fail(msg){ errBox.textContent = msg; errBox.classList.add('show'); return false; }

  function validate(){
    const s = steps[current];
    if (s.dataset.contact){
      const name  = document.getElementById('fName').value.trim();
      const phone = document.getElementById('fPhone').value.replace(/[^\d+]/g,'');
      const email = document.getElementById('fEmail').value.trim();
      if (name.length < 2) return fail('We need a name to put on the job.');
      if (phone.length < 8) return fail('Please enter a valid mobile number.');
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return fail('Please enter a valid email address.');
      return true;
    }
    // every radio group on this step needs an answer
    const groups = [];
    s.querySelectorAll('input[type=radio]').forEach(function(r){
      if (groups.indexOf(r.name) === -1) groups.push(r.name);
    });
    for (let i = 0; i < groups.length; i++){
      if (!s.querySelector('input[name="' + groups[i] + '"]:checked')) return fail('Pick one to keep going.');
    }
    // every text field on this step needs filling
    const texts = s.querySelectorAll('input[type=text],input[type=tel]');
    for (let i = 0; i < texts.length; i++){
      if (texts[i].value.trim().length < 2) return fail("Fill this in and we'll move on.");
    }
    return true;
  }

  function advance(){
    if (!validate()) return;
    if (current < steps.length - 1){ hasAdvanced = true; current++; render(); scrollToForm(); }
    else submit();
  }
  function scrollToForm(){
    const shell = document.querySelector('.formshell');
    if (shell) shell.scrollIntoView({behavior:'smooth', block:'center'});
  }

  nextBtn.addEventListener('click', advance);
  backBtn.addEventListener('click', () => { if (current > 0){ hasAdvanced = true; current--; render(); } });
  form.addEventListener('keydown', e => { if (e.key === 'Enter'){ e.preventDefault(); advance(); } });

  /* ---- payload ---- */
  function tracking(){
    const p = new URLSearchParams(location.search);
    const out = {};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','ad_id','adset_id','campaign_id']
      .forEach(k => { if (p.get(k)) out[k] = p.get(k); });
    return out;
  }
  function tags(){
    const t = [];
    const mode = quoteMode();
    if (mode === 'apartment') t.push('QUOTE_APARTMENT');
    if (mode === 'longrun')   t.push('QUOTE_LONG_RUN');
    if (!mode) t.push('PRICED');
    if (val('solar') === 'Yes') t.push('solar_connect');
    return t;
  }
  async function submit(){
    nextBtn.disabled = true;
    nextBtn.textContent = 'Sending…';

    const mode = quoteMode();
    const d = {
      'Name':            document.getElementById('fName').value.trim(),
      'Phone':           document.getElementById('fPhone').value.trim(),
      'Car':             document.getElementById('fVehicle').value.trim(),
      'Suburb':          document.getElementById('fSuburb').value.trim(),
      'Home type':       val('residence_type') || '',
      'Storeys':         val('storeys') || '',
      'Roof':            val('roof') || '',
      'Solar':           val('solar') || '',
      'Cable run':       val('cable_run') || '',
      'Quoted price':    mode ? 'Needs a quote' : money(total()),
      'Price breakdown': mode ? '' : lines().map(l => l.label + ' ' + money(l.amount)).join(' | '),
      'Tags':            tags().join(', '),
      'Submitted':       new Date().toLocaleString('en-AU')
    };
    Object.assign(d, tracking());
    const email = document.getElementById('fEmail').value.trim();
    const firstName = d['Name'].split(' ')[0];

    const body = new URLSearchParams();
    body.append('form_type', 'contact');
    body.append('utf8', '\u2713');
    body.append('contact[email]', email);
    Object.keys(d).forEach(k => body.append('contact[' + k + ']', d[k]));

    try {
      const W3F_KEY = '4fac3392-07bf-49c2-b8c9-20b3c47bad40';
      const r = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify(Object.assign({
          access_key: W3F_KEY,
          subject: 'New EV charger enquiry - ' + d['Name'] + ', ' + d['Suburb'] + ' (' + d['Quoted price'] + ')',
          from_name: 'EV Charge Group website',
          email: email,
          replyto: email
        }, d))
      });
      const j = await r.json().catch(function(){ return {}; });
      if (!r.ok || !j.success) throw new Error(j.message || 'not delivered');
      const hook = (window.ECG_CONFIG && window.ECG_CONFIG.FORM_ENDPOINT) || null;
      if (hook){
        fetch(hook, {method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify(Object.assign({}, d, {Email: email}))}).catch(function(){});
      }
      if (typeof fbq === 'function') fbq('track','Lead');
      setTimeout(function(){ window.location.href = '/pages/thank-you'; }, 400);

      const t = document.getElementById('doneTitle');
      t.textContent = t.textContent.replace('Thanks', 'Thanks ' + firstName);
      form.style.display = 'none';
      document.getElementById('navRow').style.display = 'none';
      panel.hidden = true; quoteNote.hidden = true;
      document.getElementById('done').classList.add('show');
      fill.style.width = '100%';
      title.textContent = 'Sent';
      scrollToForm();
    } catch (e){
      nextBtn.disabled = false;
      nextBtn.textContent = 'Submit';
      const ph = (window.ECG_CONFIG && window.ECG_CONFIG.PHONE) || '';
      fail("That didn't send (" + (e && e.message ? e.message : 'error') + ")." + (ph ? " Call us on " + ph + "." : " Please try again."));
    }
  }

  document.addEventListener('ecg:vehicle-prefilled', render);
  document.addEventListener('ecg:vehicle-cleared', render);

  render();
})();

/* Theme editor rebuilds sections without a reload */
if (window.Shopify && Shopify.designMode){
  document.addEventListener('shopify:section:load', function(e){
    if (e.target && e.target.querySelector && e.target.querySelector('#leadForm')) location.reload();
  });
}

/* ============================================================
   Vehicle memory, popup, sticky bar
   ============================================================ */
(function(){
  var KEY = 'ecg_vehicle';
  var store = {
    get: function(){ try { return localStorage.getItem(KEY) || ''; } catch(e){ return ''; } },
    set: function(v){ try { localStorage.setItem(KEY, v); } catch(e){} },
    clear: function(){ try { localStorage.removeItem(KEY); } catch(e){} }
  };

  var btn   = document.getElementById('vehicleBtn');
  var modal = document.getElementById('carModal');
  var input = document.getElementById('carModalInput');
  var go    = document.getElementById('carModalGo');

  function paintButton(){
    if (!btn) return;
    var v = store.get();
    var txt = btn.querySelector('.hv-txt');
    var x   = btn.querySelector('.hv-x');
    if (v){
      txt.textContent = v;
      btn.classList.add('has-vehicle');
      if (x) x.hidden = false;
    } else {
      txt.textContent = btn.getAttribute('data-empty-label') || 'Your vehicle';
      btn.classList.remove('has-vehicle');
      if (x) x.hidden = true;
    }
  }

  function fillForm(){
    var f = document.getElementById('fVehicle');
    var v = store.get();
    if (!f) return;
    if (v && !f.value){
      f.value = v;
      var step = f.closest('.stepq');
      if (step) step.setAttribute('data-prefilled', '1');
      document.dispatchEvent(new CustomEvent('ecg:vehicle-prefilled'));
    }
  }

  function setVehicle(v){
    v = (v || '').trim();
    if (!v) return;
    store.set(v); paintButton(); fillForm();
  }

  function openModal(){
    if (!modal) return;
    modal.hidden = false;
    setTimeout(function(){ input && input.focus(); }, 120);
  }
  function closeModal(){
    if (!modal) return;
    modal.hidden = true;
    var freq = modal.getAttribute('data-frequency') || 'session';
    try {
      if (freq === 'session') sessionStorage.setItem('ecg_popup_seen','1');
      if (freq === 'once')    localStorage.setItem('ecg_popup_seen','1');
    } catch(e){}
  }

  if (modal){
    modal.querySelectorAll('[data-close]').forEach(function(el){ el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && !modal.hidden) closeModal(); });
    if (go) go.addEventListener('click', function(){ setVehicle(input.value); closeModal(); });
    if (input) input.addEventListener('keydown', function(e){
      if (e.key === 'Enter'){ e.preventDefault(); setVehicle(input.value); closeModal(); }
    });

    var freq = modal.getAttribute('data-frequency') || 'session';
    var seen = false;
    try {
      if (freq === 'session') seen = sessionStorage.getItem('ecg_popup_seen') === '1';
      if (freq === 'once')    seen = localStorage.getItem('ecg_popup_seen') === '1';
    } catch(e){}
    var onMobile   = window.matchMedia('(max-width:640px)').matches;
    var mobileOff  = modal.getAttribute('data-mobile') === 'false';
    var isEditor   = !!(window.Shopify && window.Shopify.designMode);
    if (!seen && !store.get() && !isEditor && !(onMobile && mobileOff)){
      setTimeout(openModal, parseInt(modal.getAttribute('data-delay') || '10', 10) * 1000);
    }
  }

  /* header button: no car -> open popup. car set -> tap the x to clear, tap the rest to change */
  if (btn){
    btn.addEventListener('click', function(e){
      var hitX = e.target.closest && e.target.closest('.hv-x');
      if (hitX && store.get()){
        store.clear(); paintButton();
        var f = document.getElementById('fVehicle');
        if (f){ f.value = ''; var s = f.closest('.stepq'); if (s) s.removeAttribute('data-prefilled'); }
        document.dispatchEvent(new CustomEvent('ecg:vehicle-cleared'));
        return;
      }
      if (input) input.value = store.get();
      openModal();
    });
  }

  var formVehicle = document.getElementById('fVehicle');
  if (formVehicle) formVehicle.addEventListener('change', function(){ setVehicle(formVehicle.value); });

  paintButton();
  fillForm();

  var bar = document.getElementById('stickyBar');
  if (bar){
    document.body.classList.add('has-sticky');
    var book = document.getElementById('book');
    function tick(){
      var past = window.scrollY > (window.innerHeight * 0.7);
      var overForm = false;
      if (book){
        var r = book.getBoundingClientRect();
        overForm = r.top < window.innerHeight * 0.9 && r.bottom > 0;
      }
      bar.hidden = false;
      bar.classList.toggle('show', past && !overForm);
    }
    var raf = null;
    window.addEventListener('scroll', function(){
      if (raf) return;
      raf = requestAnimationFrame(function(){ tick(); raf = null; });
    }, {passive:true});
    tick();
  }
})();